module.exports = __webpack_public_path__ + "media/images/icon-share-ec37395e7c1ea69286e2b77d9b3eb11d.png";